// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"c0439043","317":"c1e5cb31","734":"95104e4b"}[chunkId] + ".chunk.js";
};